import React from 'react';

const NoDataFound = () => {
    return (
        <div>
            <h1 style={{color:'red',margin:"120px"}} >No Data Found 404</h1>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
        </div>
    );
};

export default NoDataFound;